export default "__VITE_ASSET__BZOf_AzO__"